export enum QuestTypeEnum {
  MONAD = 'MONAD',
  FASTLANE_MONAD = 'FASTLANE_MONAD',
}
